"use strict";

import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import { AppDispatcher } from 'Dispatcher';
import StoreClass from 'Store';
import { SideDrawerListConstants } from 'Constants/SideDrawerListConstants';
import { topBarSetTitle } from "Actions/TopBarActions";
import { LoginFormConstants } from "Constants/Login/LoginFormConstants";
var _store = {
  list: {},
  scrollTop: 0,
  activeItemName: null
};
var CHANGE_EVENT = 'change';

var SideDrawerListStoreClass =
/*#__PURE__*/
function (_StoreClass) {
  _inherits(SideDrawerListStoreClass, _StoreClass);

  function SideDrawerListStoreClass() {
    _classCallCheck(this, SideDrawerListStoreClass);

    return _possibleConstructorReturn(this, _getPrototypeOf(SideDrawerListStoreClass).apply(this, arguments));
  }

  _createClass(SideDrawerListStoreClass, [{
    key: "getActiveItemName",
    value: function getActiveItemName() {
      return _store.activeItemName;
    }
  }, {
    key: "expand",
    value: function expand(id) {
      var expandListItem = function expandListItem(li, id) {
        if (li.ID == id) {
          li.Expanded = !li.Expanded;
        } else {
          for (var i = 0; i < li.Children.length; ++i) {
            expandListItem(li.Children[i], id);
          }
        }
      };

      _.each(_store.list, function (li) {
        expandListItem(li, id);
      });
    }
  }, {
    key: "activateListItem",
    value: function activateListItem(li, formID) {
      if (!li.Children.length) {
        li.IsActive = li.FormID == formID;

        if (li.IsActive) {
          li.Expanded = true;
          _store.activeItemName = li.Name;
          topBarSetTitle(li.Name);
        }
      } else {
        for (var i = 0; i < li.Children.length; ++i) {
          this.activateListItem(li.Children[i], formID);
        }
      }
    }
  }, {
    key: "activateDrawerItem",
    value: function activateDrawerItem(formID) {
      var _this = this;

      _.each(_store.list, function (li) {
        _this.activateListItem(li, formID);
      });
    }
  }, {
    key: "getList",
    value: function getList() {
      return _objectSpread({}, _store);
    }
  }]);

  return SideDrawerListStoreClass;
}(StoreClass);

var SideDrawerListStore = new SideDrawerListStoreClass();
AppDispatcher.register(function (action) {
  switch (action.actionType) {
    case SideDrawerListConstants.SIDE_DRAWER_LIST_LOADED:
      _store.list = action.list;
      var match;

      if (match = window.location.hash.match(/^#subsystem\/(\d+)/)) {
        SideDrawerListStore.activateDrawerItem(match[1]);
      }

      SideDrawerListStore.emit(CHANGE_EVENT);
      break;

    case SideDrawerListConstants.SIDE_DRAWER_LIST_ITEM_EXPANDED:
      SideDrawerListStore.expand(action.id);
      SideDrawerListStore.emit(CHANGE_EVENT);
      break;

    case SideDrawerListConstants.SIDE_DRAWER_LIST_UPDATE_SCROLL_TOP:
      _store.scrollTop = action.scrollTop;
      break;

    case SideDrawerListConstants.SIDE_DRAWER_LIST_ITEM_ACTIVATE:
      SideDrawerListStore.activateDrawerItem(+action.formID);
      SideDrawerListStore.emit(CHANGE_EVENT);
      break;

    case LoginFormConstants.DO_LOGOUT:
      _store = {
        list: {},
        scrollTop: 0
      };
      break;

    default:
      return true;
  }
});
export default SideDrawerListStore;